type TrackProps = Record<string, unknown>;

declare global {
  interface Window {
    Intercom?: (...args: any[]) => void;
    FS?: any;
  }
}

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

function getUtmContext(): TrackProps {
  try {
    if (typeof window === "undefined") return {};
    if (!window.localStorage) return {};

    const ctx: TrackProps = {};
    UTM_KEYS.forEach((key) => {
      const value = window.localStorage.getItem(key);
      if (value) ctx[key] = value;
    });
    return ctx;
  } catch (e) {
    return {};
  }
}

function getPageContext(): TrackProps {
  try {
    if (typeof window === "undefined") return {};
    return {
      pathname: window.location ? window.location.pathname : "",
      search: window.location ? window.location.search : "",
      href: window.location ? window.location.href : "",
      referrer: typeof document !== "undefined" ? document.referrer || "" : "",
      ...getUtmContext(),
    };
  } catch (e) {
    return {};
  }
}

export function trackEvent(name: string, props: TrackProps = {}): void {
  const payload = { ...getPageContext(), ...props };

  try {
    if (typeof window !== "undefined" && window.Intercom) {
      window.Intercom("trackEvent", name, payload);
    }
  } catch (e) {
    // ignore
  }

  try {
    if (
      typeof window !== "undefined" &&
      window.FS &&
      typeof window.FS.event === "function"
    ) {
      window.FS.event(name, payload);
    }
  } catch (e) {
    // ignore
  }
}

export function trackPageChange(): void {
  try {
    if (typeof window !== "undefined" && window.Intercom) {
      window.Intercom("update");
    }
  } catch (e) {
    // ignore
  }
}
